import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  // Always 10 tracks -- checkbox, 8 data columns, Actions -- matching
  // AdminConfigSessions' header unconditionally rather than growing only while a
  // bulk selection was active (BL-235: the row used to gain this column only in
  // sync with the header's own conditional growth, and nothing ever rendered into
  // it -- see the per-row terminate button below for what it now holds).
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '0.3fr 1fr 1.4fr 1fr 1fr 1fr 1fr 1fr 1fr 0.7fr',
    alignItems: 'center',
    padding: theme.spacing(1),
    margin: '4px 0'
  },
  // No checkbox, no email, no Actions column -- the Home dashboard's read-only widget.
  hideEmailRow: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr'
  },
  text: { fontWeight: 500, fontSize: 14 }
}))
